import { z } from "zod";
import { MarketingPage } from "@/bryntum-lib/models/MarketingPage";

const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const marketingPageSchema = z.object({
  slug: z
    .string()
    .min(1, "Slug is required")
    .regex(slugPattern, "Use lowercase letters, numbers, and hyphens only"),
  includeInSite: z.boolean(),
  metaTitle: z.string(),
  metaDescription: z.string(),
  canonicalUrl: z.string(),
  robotsIndex: z.boolean(),
  robotsFollow: z.boolean(),
  ogTitle: z.string(),
  ogDescription: z.string(),
  ogImageUrl: z.string(),
  twitterCard: z.string().min(1, "Twitter card type is required"),
});

export type MarketingPageFormData = z.infer<typeof marketingPageSchema>;

export function marketingPageToFormData(page: MarketingPage): MarketingPageFormData {
  return {
    slug: page.slug ?? "",
    includeInSite: Boolean(page.includeInSite),
    metaTitle: page.metaTitle ?? "",
    metaDescription: page.metaDescription ?? "",
    canonicalUrl: page.canonicalUrl ?? "",
    robotsIndex: page.robotsIndex !== false,
    robotsFollow: page.robotsFollow !== false,
    ogTitle: page.ogTitle ?? "",
    ogDescription: page.ogDescription ?? "",
    ogImageUrl: page.ogImageUrl ?? "",
    twitterCard: page.twitterCard ?? "summary_large_image",
  };
}

export function applyMarketingPageFormData(page: MarketingPage, data: MarketingPageFormData): void {
  page.set({
    slug: data.slug,
    includeInSite: data.includeInSite,
    metaTitle: data.metaTitle,
    metaDescription: data.metaDescription,
    canonicalUrl: data.canonicalUrl,
    robotsIndex: data.robotsIndex,
    robotsFollow: data.robotsFollow,
    ogTitle: data.ogTitle,
    ogDescription: data.ogDescription,
    twitterCard: data.twitterCard,
  });
}

/** Apply OG image fields from upload/delete API response (read-only in Bryntum sync). */
export function mergeOgImageApiIntoMarketingPage(
  page: MarketingPage,
  apiPage: Partial<Record<string, unknown>>,
): void {
  page.set({
    ogImageUrl: apiPage.og_image_url != null ? String(apiPage.og_image_url) : "",
    ogImageThumbnailUrl:
      apiPage.og_image_thumbnail_url != null ? String(apiPage.og_image_thumbnail_url) : "",
  });
}
